import React from 'react';
import { Input as InputField } from '@tvg/fuse/input';
import AlertsComponent from 'components/Alert/AlertsComponent';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';

interface PersonalizationProps {
  maxLength: number;
}

function Personalization(props: PersonalizationProps): JSX.Element {
  const { maxLength } = props;
  const { personalizationErrorMessage, setPersonalizationInput } = useSelectedSkuContext();
  const inputState = personalizationErrorMessage ? 'error' : undefined;
  const inputRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const personalizationInput = inputRef.current?.querySelector('input');
    setPersonalizationInput(personalizationInput);
  }, []);

  return (
    <>
      {personalizationErrorMessage && (
        <AlertsComponent dataTestId="personalization-error-alert" errorMessage={personalizationErrorMessage} />
      )}
      <InputField
        state={inputState}
        dataTestId="personalisedItem"
        helperText="E.g. I love you"
        label="Personalise your product"
        maxCharacterCount={`${maxLength}`}
        ref={inputRef}
      />
    </>
  );
}

export default Personalization;
